<script setup lang="ts">
import type { ApiResponse } from '~/types/shared'
const { t } = useI18n()

const {userId} = defineProps<{
	userId: string
}>()

  const page = ref(1)
  const per_page = ref(10)
  const transactions = ref<ApiResponse | null>(null);
  const fetchTransactions = async () => {
    const api = useApi()
    if (!userId) return;

      const requestBody: any = {
        filter: { user_id: { '$oid': toValue(userId) } },
        skip: (page.value - 1) * per_page.value,
        limit: per_page.value,
        sort: { tx_at: -1 },
      }
      transactions.value = await api.post('/api/txs/find', requestBody)
      return transactions.value
    }

watch([page, per_page], () => {
    fetchTransactions()
})

const transactionsColumns = computed(() => [
	{ label: t('data'), key: 'tx_at', sortable: true },
	{ label: t('trans_type'), key: 'slug', sortable: false },
	{
		label: t('summ'),
		key: 'ax_data.decrypted_result.transaction.localCurrencyAmt',
		sortable: false,
	},
	{
		label: t('status'),
		key: 'ax_data.decrypted_result.transaction.transStatus',
		sortable: false,
	},
	{
		label: t('info'),
		key: 'ax_data.decrypted_result.transaction.merchantName',
		sortable: false,
	},
])

if (!transactions.value) {
    fetchTransactions()
}
</script>
<template>
	<div>
		<ResponsiveTable
			:rows="transactions?.items"
			:columns="transactionsColumns"
		>
			<template #tx_at-data="{ row }">
				<DateColumn :row="row" />
			</template>
			<template #slug-data="{ row }">
				<TransactionType :row="row" />
			</template>
			<template
				#ax_data.decrypted_result.transaction.localCurrencyAmt-data="{
					row,
				}"
			>
				<SumColumn :row="row" />
			</template>
			<template
				#ax_data.decrypted_result.transaction.transStatus-data="{ row }"
			>
				<TransStatusColumn :row="row" />
			</template>
			<template
				#ax_data.decrypted_result.transaction.merchantName-data="{
					row,
				}"
			>
				<MerchantColumn :row="row" />
			</template>
		</ResponsiveTable>
		<div class="flex justify-end mt-4">
			<UPagination
				v-model="page"
				:page-count="per_page"
				:total="transactions?.meta?.filter_items_count || 0"
			/>
		</div>
	</div>
</template>
